import React from 'react';
import { LiaProjectDiagramSolid } from 'react-icons/lia';
import { NavSubmenuDivider, NavSubmenuLabel } from './navMenuLayout';
import { hasProjectBudgetNavAccess, hasProjectTenderNavAccess, PROJECT_CHILD_ROUTES } from './projects/projectNavConfig';

export default function ProjectsNavSection({
  MenuItem,
  SubMenuItem,
  ActionMenuItem,
  hasMenuAccess,
  hasMenuAccessOrChild,
  hasProjects,
  activeProject,
  hasApprovedBudget,
  onNewProject,
  hideNewProject = false,
}) {
  if (!hasMenuAccess('/projects') && !hasMenuAccessOrChild('/projects', PROJECT_CHILD_ROUTES)) {
    return null;
  }

  const showBudgetSection = hasProjectBudgetNavAccess(hasMenuAccess, { activeProject, hasApprovedBudget });
  const showTender = hasProjectTenderNavAccess(hasMenuAccess, { activeProject });

  return (
    <MenuItem customIcon={<LiaProjectDiagramSolid style={{ width: '24px', height: '24px' }} />} title="Project" id="projects">
      {!activeProject && !hideNewProject && (
        <ActionMenuItem onClick={onNewProject}>+ New Project</ActionMenuItem>
      )}
      {hasProjects && hasMenuAccess('/projects/portfolio') && (
        <SubMenuItem to="/projects/portfolio">Project List</SubMenuItem>
      )}
      {activeProject && (
        <>
          {hasApprovedBudget && hasMenuAccess('/projects/dashboard') && (
            <SubMenuItem to={`/projects/${activeProject.project_id}/dashboard`}>Dashboard</SubMenuItem>
          )}
          {hasMenuAccess('/projects/scope') && (
            <SubMenuItem to={`/projects/${activeProject.project_id}/scope`}>Project Scope</SubMenuItem>
          )}
          {showTender && (
            <SubMenuItem to={`/projects/${activeProject.project_id}/tender`}>Approved Tender</SubMenuItem>
          )}
          {hasMenuAccess('/projects/schedule') && (
            <SubMenuItem to={`/projects/${activeProject.project_id}/schedule`}>Schedule (Gantt)</SubMenuItem>
          )}
          {hasMenuAccess('/projects/combined-progress') && (
            <SubMenuItem to="/projects/combined-progress">Progress Map</SubMenuItem>
          )}
          {showBudgetSection && (
            <>
              <NavSubmenuDivider />
              <NavSubmenuLabel>Budget</NavSubmenuLabel>
              {hasApprovedBudget && hasMenuAccess('/master-budget') && (
                <SubMenuItem to="/master-budget">Master Budget</SubMenuItem>
              )}
              {hasMenuAccess('/budgets/management') && (
                <SubMenuItem to="/budgets/management">Budget Management</SubMenuItem>
              )}
            </>
          )}
        </>
      )}
    </MenuItem>
  );
}
